import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CaseManagerComponent } from './case-manager.component';

const routes: Routes = [{ path: '', component:CaseManagerComponent,pathMatch:'full'  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagerRoutingModule { }
